var map = {
	"./2021/10-17/architecture_first_attempt.png": 3232,
	"./2021/10-17/architecture_second_attempt.png": 5468,
	"./2022/11-25/scooby_doo.gif": 6186,
	"./2023/11-08/new_about_me.png": 2430,
	"./2023/11-08/old_about_me.png": 5121,
	"./2023/11-08/share_button.png": 8523,
	"./2023/11-08/share_button_preview.png": 4038,
	"./2024/haruka_sawamura.png": 7486,
	"./2024/rock_paper_invaders_background.png": 9988,
	"./2024/untitled_2024_01_07.png": 5890,
	"./2025/kabu_preview_1_1.png": 1929,
	"./2025/kabu_preview_1_2.png": 2194,
	"./2025/kabu_preview_1_3.png": 3323,
	"./2025/kabu_preview_1_4.png": 7060,
	"./2025/kabu_preview_1_5.png": 93,
	"./2025/kabu_preview_2_1.png": 3206,
	"./2025/kabu_preview_2_2.png": 7181,
	"./2025/kabu_preview_2_3.png": 3284,
	"./2025/kabu_preview_2_4.png": 7147,
	"./2025/kabu_preview_2_5.png": 2322,
	"./2025/kabu_preview_2_6.png": 3289,
	"./2025/kabu_preview_2_7.png": 8816,
	"./2025/kabu_preview_2_8.png": 9911,
	"./2025/kabu_preview_2_9.png": 7422,
	"./2025/wario.png": 5221,
	"./2026/kabu_preview_4_1.png": 2769,
	"./2026/kabu_preview_4_2.png": 2602,
	"./2026/kabu_preview_5_1.png": 1440,
	"./2026/kabu_preview_5_2.png": 6475,
	"./2026/kabu_preview_5_3.png": 7474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8878;